/* import __COLOCATED_TEMPLATE__ from './trigger-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();